export  const authConstants = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOADING: "LOADING",
  RESPONSE_STATE:"RESPONSE_STATE",
  LOG_OUT:"LOG_OUT",
  GET_USER_BY_ID:"GET_USER_BY_ID"
};
